var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitasProductCardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123.912,
    height: 43.68,
    viewBox: "0 0 123.912 43.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2125",
    "data-name": "Rectangle 2125",
    width: 123.912,
    height: 29.344,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657",
    transform: "translate(-486.855 -2160.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2531",
    "data-name": "Group 2531",
    transform: "translate(486.855 2160.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2530",
    "data-name": "Group 2530",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2529",
    "data-name": "Group 2529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M653.117,39.777a.027.027,0,0,1-.025.035h-1.078c-.757,0-1.515.014-2.27-.012-.141,0-.379-.139-.4-.25a3.273,3.273,0,0,0-2.724-2.459,18.031,18.031,0,0,0-9.054.037,6.968,6.968,0,0,0-2.159,1.078,1.825,1.825,0,0,0-.718,2.2,2.243,2.243,0,0,0,.75.967,8.8,8.8,0,0,0,3.318,1.383c2.54.6,5.105,1.111,7.652,1.686a20.969,20.969,0,0,1,4.706,1.547c3.928,1.93,3.632,6.052,1.4,8.407a9.907,9.907,0,0,1-4.443,2.558,21.327,21.327,0,0,1-7.728.656,16.85,16.85,0,0,1-5.392-1.131,7.006,7.006,0,0,1-4.551-5.168c-.048-.226-.065-.462-.1-.741a.03.03,0,0,1,.03-.032c1.185,0,2.318,0,3.454.009a.323.323,0,0,1,.233.2c.436,2.083,1.967,3.05,3.817,3.514a17.514,17.514,0,0,0,9.6-.15,4.739,4.739,0,0,0,2.4-1.512,2.527,2.527,0,0,0-.744-3.935,15.887,15.887,0,0,0-4.41-1.455c-2.563-.57-5.14-1.085-7.7-1.667a11.8,11.8,0,0,1-4.068-1.716,4.874,4.874,0,0,1-.257-7.7,9.884,9.884,0,0,1,3.979-1.893,24.3,24.3,0,0,1,7.368-.469,16.97,16.97,0,0,1,5.115.977,5.638,5.638,0,0,1,3.671,3.521,15.287,15.287,0,0,1,.337,1.512",
    transform: "translate(-530.228 -28.37)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M488.781,42.044c.032,4.944.011,9.89.009,14.835,0,.053-.009.108-.018.243a.03.03,0,0,1-.03.025h-1.773c-.464,0-.931-.019-1.395,0-.356.019-.494-.092-.48-.464.025-.67.009-1.337.009-2.057a.029.029,0,0,0-.039-.026,1.878,1.878,0,0,0-.279.106,18.9,18.9,0,0,1-6.913,2.658,18.246,18.246,0,0,1-8.878-.379,7.255,7.255,0,0,1-4.332-3.369,5.871,5.871,0,0,1,1.418-7.029,12.81,12.81,0,0,1,5.193-2.651,30.115,30.115,0,0,1,7.1-1.053c2.078-.078,4.156-.078,6.237-.088.383,0,.533-.106.478-.494a22.559,22.559,0,0,0-.3-2.24,3.8,3.8,0,0,0-2.17-2.531,9.371,9.371,0,0,0-3.4-.864,21.654,21.654,0,0,0-6.25.261,10.981,10.981,0,0,0-2.572.9,3.176,3.176,0,0,0-1.757,2.268c-.069.33-.231.434-.57.427-1.018-.023-2.039-.009-3.106-.009a.029.029,0,0,1-.028-.03,5.655,5.655,0,0,1,.538-2.145,6.8,6.8,0,0,1,4.156-3.614,19.787,19.787,0,0,1,6.47-1.009,23.164,23.164,0,0,1,6.193.527,8.487,8.487,0,0,1,5.2,3.249,7.881,7.881,0,0,1,1.3,4.546m-3.662,4.08c0-.358-.12-.476-.48-.469-1.148.018-2.3.007-3.445.007a36.6,36.6,0,0,0-8.015.688,9.47,9.47,0,0,0-4.142,1.833,3.4,3.4,0,0,0-1.1,3.842,3.335,3.335,0,0,0,1.642,1.676,10.843,10.843,0,0,0,4.881,1.118,15.833,15.833,0,0,0,10.4-3.6.69.69,0,0,0,.229-.471c.021-1.542.011-3.083.028-4.623",
    transform: "translate(-390.374 -28.388)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M388.734,26.656c.3,0,.39.067.386.351-.014.683-.007,1.367-.007,2.05,0,.2-.021.376-.289.395a18.713,18.713,0,0,1-5.253-.136,4.131,4.131,0,0,1-3.6-4.239c-.155-2.674-.079-5.313-.134-7.992,0-.016,0-.085,0-.1,0-2.392-.007-4.782.009-7.172,0-.413-.111-.559-.538-.545-.974.028-1.949,0-2.923.014-.28,0-.39-.083-.386-.372q.021-1.067,0-2.138c-.007-.3.1-.4.406-.4.988.016,1.976-.009,2.965.014.367.009.476-.116.471-.473-.014-1.6,0-3.2-.016-4.8,0-.406.1-.568.534-.554.887.03,1.776.023,2.662,0,.353-.007.48.1.476.466-.018,1.63,0,3.258-.016,4.886,0,.36.1.476.464.471,1.323-.021,2.646,0,3.969-.016.349,0,.5.076.48.455-.028.667-.028,1.339,0,2.007.016.379-.136.457-.48.452-1.309-.016-2.618,0-3.928-.014-.365,0-.508.081-.505.48.011,4.466-.009,8.929.028,13.392a6.886,6.886,0,0,0,.413,2.115,2.142,2.142,0,0,0,2.115,1.339c.9.067,1.8.067,2.7.058",
    transform: "translate(-316.316 -0.502)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M338.92.571v3.29a.386.386,0,0,1-.386.383h-3.281a.384.384,0,0,1-.383-.383V.571a.383.383,0,0,1,.383-.383h3.281a.384.384,0,0,1,.386.383",
    transform: "translate(-281.718 -0.188)",
    fill: "#a51f27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M339.646,37.143c.388-.011.494.118.492.5-.012,2.866,0,5.729,0,8.594V59.448c0,.582,0,.584-.563.584-.873,0-1.746-.021-2.618.007-.388.012-.487-.115-.485-.494.014-3.651.009-7.3.009-10.947h0c0-3.65,0-7.3-.009-10.949,0-.407.118-.517.515-.506.887.03,1.773.028,2.66,0",
    transform: "translate(-283.063 -31.273)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M192.256,42.186c.016,4.814,0,9.629.016,14.443,0,.425-.122.545-.538.531-.87-.03-1.746-.032-2.616,0-.418.016-.51-.132-.51-.522q.014-7.069,0-14.136a11.955,11.955,0,0,0-.2-2.166,4.251,4.251,0,0,0-3.752-3.5A12.973,12.973,0,0,0,174.2,39.323c-.6.427-1.383.792-1.7,1.388a4.888,4.888,0,0,0-.136,2.129q-.014,6.9,0,13.79c0,.422-.115.547-.536.531-.857-.032-1.718-.037-2.574,0-.455.018-.557-.138-.557-.57q.017-9.75,0-19.5c0-.785.014-1.57-.009-2.355-.009-.363.111-.478.476-.469.9.023,1.8.025,2.7,0,.374-.012.512.081.494.478-.032.764-.012,1.529-.009,2.372a.028.028,0,0,0,.044.023c.76-.508,1.413-.991,2.108-1.4a14.716,14.716,0,0,1,7.657-2.016,15,15,0,0,1,5.408.739,6.73,6.73,0,0,1,4.489,5.436,13.164,13.164,0,0,1,.189,2.3",
    transform: "translate(-141.935 -28.392)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M23.8,37.547q-.014,11.038,0,22.077c0,.312-.111.406-.406.4-.944-.011-1.891-.011-2.835,0-.3,0-.418-.088-.409-.4.016-.552,0-1.106,0-1.658,0-.136-.016-.27-.023-.374a.029.029,0,0,0-.042-.023c-1.145.575-2.214,1.205-3.353,1.653a18.312,18.312,0,0,1-10.31,1.055,7.046,7.046,0,0,1-5.369-3.824A9.745,9.745,0,0,1,.192,52.1q0-7.263,0-14.528c0-.3.055-.446.4-.439.958.023,1.919.016,2.879,0,.275,0,.411.081.4.367,0,.173.014.349.014.522-.007,4.625-.025,9.25-.007,13.875a10.455,10.455,0,0,0,.266,2.286,4.2,4.2,0,0,0,3.7,3.276,13.19,13.19,0,0,0,11.314-3.124,2.518,2.518,0,0,0,1.021-2.207c-.053-4.8-.025-9.6-.025-14.4,0-.589,0-.589.593-.589.873,0,1.746.009,2.618-.007.31-.007.436.072.436.411",
    transform: "translate(-0.188 -31.264)",
    fill: "gray"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M294.127,219v3.917h-.338v-9.125h2.852a3.086,3.086,0,0,1,2.181.711,2.733,2.733,0,0,1,0,3.789,3.09,3.09,0,0,1-2.184.708Zm0-.338h2.513a2.674,2.674,0,0,0,1.952-.645,2.17,2.17,0,0,0,.655-1.611,2.2,2.2,0,0,0-.652-1.633,2.68,2.68,0,0,0-1.955-.642h-2.513Z",
    transform: "translate(239.694 1980.161)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M294.127,219v3.917h-.338v-9.125h2.852a3.086,3.086,0,0,1,2.181.711,2.733,2.733,0,0,1,0,3.789,3.09,3.09,0,0,1-2.184.708Zm0-.338h2.513a2.674,2.674,0,0,0,1.952-.645,2.17,2.17,0,0,0,.655-1.611,2.2,2.2,0,0,0-.652-1.633,2.68,2.68,0,0,0-1.955-.642h-2.513Z",
    transform: "translate(239.694 1980.161)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M342.666,219v3.917h-.339v-9.125h2.852a3.086,3.086,0,0,1,2.181.711,2.733,2.733,0,0,1,0,3.789,3.09,3.09,0,0,1-2.184.708Zm0-.338h2.513a2.673,2.673,0,0,0,1.952-.645,2.17,2.17,0,0,0,.655-1.611,2.2,2.2,0,0,0-.652-1.633,2.68,2.68,0,0,0-1.955-.642h-2.513Z",
    transform: "translate(198.863 1980.161)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M342.666,219v3.917h-.339v-9.125h2.852a3.086,3.086,0,0,1,2.181.711,2.733,2.733,0,0,1,0,3.789,3.09,3.09,0,0,1-2.184.708Zm0-.338h2.513a2.673,2.673,0,0,0,1.952-.645,2.17,2.17,0,0,0,.655-1.611,2.2,2.2,0,0,0-.652-1.633,2.68,2.68,0,0,0-1.955-.642h-2.513Z",
    transform: "translate(198.863 1980.161)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M395.1,218.342a4.389,4.389,0,0,1-.915,2.93,3.487,3.487,0,0,1-5.048,0,4.379,4.379,0,0,1-.918-2.93v-1.366a4.4,4.4,0,0,1,.912-2.927,3.48,3.48,0,0,1,5.048,0,4.372,4.372,0,0,1,.921,2.927Zm-.338-1.379a4.1,4.1,0,0,0-.809-2.67,3.152,3.152,0,0,0-4.588,0,4.119,4.119,0,0,0-.8,2.67v1.379a4.128,4.128,0,0,0,.805,2.682,3.159,3.159,0,0,0,4.591,0,4.137,4.137,0,0,0,.8-2.685Z",
    transform: "translate(160.257 1980.859)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M395.1,218.342a4.389,4.389,0,0,1-.915,2.93,3.487,3.487,0,0,1-5.048,0,4.379,4.379,0,0,1-.918-2.93v-1.366a4.4,4.4,0,0,1,.912-2.927,3.48,3.48,0,0,1,5.048,0,4.372,4.372,0,0,1,.921,2.927Zm-.338-1.379a4.1,4.1,0,0,0-.809-2.67,3.152,3.152,0,0,0-4.588,0,4.119,4.119,0,0,0-.8,2.67v1.379a4.128,4.128,0,0,0,.805,2.682,3.159,3.159,0,0,0,4.591,0,4.137,4.137,0,0,0,.8-2.685Z",
    transform: "translate(160.257 1980.859)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M466.35,220.035a1.681,1.681,0,0,0-.63-1.373,6.216,6.216,0,0,0-2.184-.94,7.031,7.031,0,0,1-2.284-.956,1.824,1.824,0,0,1-.724-1.564,1.9,1.9,0,0,1,.852-1.63,3.656,3.656,0,0,1,2.175-.608,3.177,3.177,0,0,1,2.181.746,2.368,2.368,0,0,1,.821,1.918l-.013.038h-.288a2.17,2.17,0,0,0-.752-1.692,2.819,2.819,0,0,0-1.949-.671,3.153,3.153,0,0,0-1.965.555,1.636,1.636,0,0,0-.125,2.623,5.626,5.626,0,0,0,2.165.915,6.754,6.754,0,0,1,2.291.981,1.934,1.934,0,0,1,.774,1.645,1.98,1.98,0,0,1-.884,1.708,3.743,3.743,0,0,1-2.212.624,4.244,4.244,0,0,1-2.363-.642,2.17,2.17,0,0,1-.959-2.021l.013-.038h.282a1.953,1.953,0,0,0,.915,1.8,3.958,3.958,0,0,0,2.112.561,3.325,3.325,0,0,0,1.977-.552,1.683,1.683,0,0,0,.774-1.429",
    transform: "translate(99.647 1980.859)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M466.35,220.035a1.681,1.681,0,0,0-.63-1.373,6.216,6.216,0,0,0-2.184-.94,7.031,7.031,0,0,1-2.284-.956,1.824,1.824,0,0,1-.724-1.564,1.9,1.9,0,0,1,.852-1.63,3.656,3.656,0,0,1,2.175-.608,3.177,3.177,0,0,1,2.181.746,2.368,2.368,0,0,1,.821,1.918l-.013.038h-.288a2.17,2.17,0,0,0-.752-1.692,2.819,2.819,0,0,0-1.949-.671,3.153,3.153,0,0,0-1.965.555,1.636,1.636,0,0,0-.125,2.623,5.626,5.626,0,0,0,2.165.915,6.754,6.754,0,0,1,2.291.981,1.934,1.934,0,0,1,.774,1.645,1.98,1.98,0,0,1-.884,1.708,3.743,3.743,0,0,1-2.212.624,4.244,4.244,0,0,1-2.363-.642,2.17,2.17,0,0,1-.959-2.021l.013-.038h.282a1.953,1.953,0,0,0,.915,1.8,3.958,3.958,0,0,0,2.112.561,3.325,3.325,0,0,0,1.977-.552A1.683,1.683,0,0,0,466.35,220.035Z",
    transform: "translate(99.647 1980.859)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M507.835,231.148a3.578,3.578,0,0,1,.824-2.438,2.9,2.9,0,0,1,4.287,0,3.578,3.578,0,0,1,.824,2.438v.263a3.587,3.587,0,0,1-.824,2.444,2.9,2.9,0,0,1-4.284,0,3.578,3.578,0,0,1-.827-2.444Zm.338.263a3.342,3.342,0,0,0,.714,2.165,2.507,2.507,0,0,0,3.829,0,3.345,3.345,0,0,0,.714-2.162v-.263a3.327,3.327,0,0,0-.721-2.146,2.481,2.481,0,0,0-3.823,0,3.346,3.346,0,0,0-.714,2.146Z",
    transform: "translate(59.64 1968.41)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M507.835,231.148a3.578,3.578,0,0,1,.824-2.438,2.9,2.9,0,0,1,4.287,0,3.578,3.578,0,0,1,.824,2.438v.263a3.587,3.587,0,0,1-.824,2.444,2.9,2.9,0,0,1-4.284,0,3.578,3.578,0,0,1-.827-2.444Zm.338.263a3.342,3.342,0,0,0,.714,2.165,2.507,2.507,0,0,0,3.829,0,3.345,3.345,0,0,0,.714-2.162v-.263a3.327,3.327,0,0,0-.721-2.146,2.481,2.481,0,0,0-3.823,0,3.346,3.346,0,0,0-.714,2.146Z",
    transform: "translate(59.64 1968.41)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2126",
    "data-name": "Rectangle 2126",
    width: 0.338,
    height: 9.777,
    transform: "translate(575.116 2193.304)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2127",
    "data-name": "Rectangle 2127",
    width: 0.338,
    height: 9.777,
    transform: "translate(575.116 2193.304)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M576.5,234.118a2.327,2.327,0,0,1-.912,1,2.775,2.775,0,0,1-1.438.351,1.98,1.98,0,0,1-1.639-.742,3.673,3.673,0,0,1-.592-2.3v-3.867h.339v3.879a3.329,3.329,0,0,0,.508,2.037,1.642,1.642,0,0,0,1.373.658,2.323,2.323,0,0,0,1.626-.52,2.392,2.392,0,0,0,.724-1.379v-4.675h.344v6.781h-.282Z",
    transform: "translate(5.733 1967.746)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M576.5,234.118a2.327,2.327,0,0,1-.912,1,2.775,2.775,0,0,1-1.438.351,1.98,1.98,0,0,1-1.639-.742,3.673,3.673,0,0,1-.592-2.3v-3.867h.339v3.879a3.329,3.329,0,0,0,.508,2.037,1.642,1.642,0,0,0,1.373.658,2.323,2.323,0,0,0,1.626-.52,2.392,2.392,0,0,0,.724-1.379v-4.675h.344v6.781h-.282Z",
    transform: "translate(5.733 1967.746)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M612.272,217.03v1.83h1.667v.345h-1.667v4.688a1.933,1.933,0,0,0,.282,1.188.906.906,0,0,0,.746.354c.113,0,.213,0,.3-.013s.209-.023.364-.044l.063.307a1.671,1.671,0,0,1-.326.069,3.494,3.494,0,0,1-.382.019,1.246,1.246,0,0,1-1.037-.445,2.312,2.312,0,0,1-.354-1.435V219.2h-1.253v-.345h1.253v-1.83Z",
    transform: "translate(-26.866 1977.439)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M612.272,217.03v1.83h1.667v.345h-1.667v4.688a1.933,1.933,0,0,0,.282,1.188.906.906,0,0,0,.746.354c.113,0,.213,0,.3-.013s.209-.023.364-.044l.063.307a1.671,1.671,0,0,1-.326.069,3.494,3.494,0,0,1-.382.019,1.246,1.246,0,0,1-1.037-.445,2.312,2.312,0,0,1-.354-1.435V219.2h-1.253v-.345h1.253v-1.83Z",
    transform: "translate(-26.866 1977.439)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M642.147,210.555h-.338v-.865h.338Zm0,8.912h-.338v-6.781h.338Z",
    transform: "translate(-53.057 1983.614)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M642.147,210.555h-.338v-.865h.338Zm0,8.912h-.338v-6.781h.338Z",
    transform: "translate(-53.057 1983.614)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M654.595,231.148a3.579,3.579,0,0,1,.824-2.438,2.9,2.9,0,0,1,4.287,0,3.578,3.578,0,0,1,.824,2.438v.263a3.587,3.587,0,0,1-.824,2.444,2.9,2.9,0,0,1-4.284,0,3.578,3.578,0,0,1-.827-2.444Zm.338.263a3.342,3.342,0,0,0,.715,2.165,2.507,2.507,0,0,0,3.829,0,3.344,3.344,0,0,0,.714-2.162v-.263a3.326,3.326,0,0,0-.721-2.146,2.481,2.481,0,0,0-3.823,0,3.346,3.346,0,0,0-.715,2.146Z",
    transform: "translate(-63.812 1968.41)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M654.595,231.148a3.579,3.579,0,0,1,.824-2.438,2.9,2.9,0,0,1,4.287,0,3.578,3.578,0,0,1,.824,2.438v.263a3.587,3.587,0,0,1-.824,2.444,2.9,2.9,0,0,1-4.284,0,3.578,3.578,0,0,1-.827-2.444Zm.338.263a3.342,3.342,0,0,0,.715,2.165,2.507,2.507,0,0,0,3.829,0,3.344,3.344,0,0,0,.714-2.162v-.263a3.326,3.326,0,0,0-.721-2.146,2.481,2.481,0,0,0-3.823,0,3.346,3.346,0,0,0-.715,2.146Z",
    transform: "translate(-63.812 1968.41)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M702.475,227.889l.044,1.4a2.48,2.48,0,0,1,.9-1.125,2.538,2.538,0,0,1,1.454-.4,2,2,0,0,1,1.664.7,3.563,3.563,0,0,1,.555,2.215v3.992h-.339v-4a3.033,3.033,0,0,0-.5-1.987,1.726,1.726,0,0,0-1.369-.577,2.053,2.053,0,0,0-1.655.655,3.177,3.177,0,0,0-.7,1.676v4.236h-.338v-6.781Z",
    transform: "translate(-103.845 1968.41)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M702.475,227.889l.044,1.4a2.48,2.48,0,0,1,.9-1.125,2.538,2.538,0,0,1,1.454-.4,2,2,0,0,1,1.664.7,3.563,3.563,0,0,1,.555,2.215v3.992h-.339v-4a3.033,3.033,0,0,0-.5-1.987,1.726,1.726,0,0,0-1.369-.577,2.053,2.053,0,0,0-1.655.655,3.177,3.177,0,0,0-.7,1.676v4.236h-.338v-6.781Z",
    transform: "translate(-103.845 1968.41)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M748.574,233.011a1.337,1.337,0,0,0-.461-.981,3.4,3.4,0,0,0-1.607-.692,4.633,4.633,0,0,1-1.752-.661,1.4,1.4,0,0,1-.542-1.2,1.5,1.5,0,0,1,.614-1.219,2.572,2.572,0,0,1,1.655-.492,2.717,2.717,0,0,1,1.767.526,1.6,1.6,0,0,1,.614,1.372l-.012.038h-.288A1.423,1.423,0,0,0,748,228.57a2.3,2.3,0,0,0-1.52-.467,2.193,2.193,0,0,0-1.441.411,1.214,1.214,0,0,0-.489.949,1.185,1.185,0,0,0,.414.909,3.893,3.893,0,0,0,1.642.658,4.477,4.477,0,0,1,1.72.718,1.515,1.515,0,0,1,.586,1.269,1.547,1.547,0,0,1-.652,1.291,2.788,2.788,0,0,1-1.73.5,2.933,2.933,0,0,1-1.858-.53,1.47,1.47,0,0,1-.63-1.288l.013-.038h.276a1.33,1.33,0,0,0,.689,1.159,3.049,3.049,0,0,0,1.51.357,2.331,2.331,0,0,0,1.492-.439,1.277,1.277,0,0,0,.552-1.015",
    transform: "translate(-139.052 1968.409)",
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M748.574,233.011a1.337,1.337,0,0,0-.461-.981,3.4,3.4,0,0,0-1.607-.692,4.633,4.633,0,0,1-1.752-.661,1.4,1.4,0,0,1-.542-1.2,1.5,1.5,0,0,1,.614-1.219,2.572,2.572,0,0,1,1.655-.492,2.717,2.717,0,0,1,1.767.526,1.6,1.6,0,0,1,.614,1.372l-.012.038h-.288A1.423,1.423,0,0,0,748,228.57a2.3,2.3,0,0,0-1.52-.467,2.193,2.193,0,0,0-1.441.411,1.214,1.214,0,0,0-.489.949,1.185,1.185,0,0,0,.414.909,3.893,3.893,0,0,0,1.642.658,4.477,4.477,0,0,1,1.72.718,1.515,1.515,0,0,1,.586,1.269,1.547,1.547,0,0,1-.652,1.291,2.788,2.788,0,0,1-1.73.5,2.933,2.933,0,0,1-1.858-.53,1.47,1.47,0,0,1-.63-1.288l.013-.038h.276a1.33,1.33,0,0,0,.689,1.159,3.049,3.049,0,0,0,1.51.357,2.331,2.331,0,0,0,1.492-.439A1.277,1.277,0,0,0,748.574,233.011Z",
    transform: "translate(-139.052 1968.409)",
    fill: "none",
    stroke: "#a62027",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitasProductCardLogo);
export default __webpack_public_path__ + "static/media/unitasProductCardLogo.d1b693ff.svg";
export { ForwardRef as ReactComponent };